/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, frFR } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link, Card, Box, IconButton, Tooltip, DialogContentText, DialogActions, DialogContent, Dialog, Button, Select, MenuItem } from '@material-ui/core';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import ComputerRoundedIcon from '@mui/icons-material/Computer';
import GroupsRoundedIcon from '@mui/icons-material/Groups';
import LayersRoundedIcon from '@mui/icons-material/Layers';
import SchoolRoundedIcon from '@mui/icons-material/School';
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutline';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import PaymentsRoundedIcon from '@mui/icons-material/Payments';
import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import { formationApi } from '../../../api/formationApi';
import toast from 'react-hot-toast';
import { useState } from 'react';
import { Pill, ListAvatar, EmptyValue } from '../../ui-kit';
import { getTone } from '../../../theme/tones';
import usePermissions from '../../../hooks/usePermissions';



const getFormatStyle = (val = '') => {
  // Formats issus de « Mixte » : testés en premier pour conserver sa couleur
  // (« Présentiel PI » contient « Présentiel » et serait sinon capté au-dessus).
  if (val === 'Présentiel PI' || val === 'Classe virtuelle PI') {
    return { tone: 'teal', icon: <LayersRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  if (val.includes('E-Learning') || val.includes('E-learning')) {
    return { tone: 'indigo', icon: <ComputerRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  if (val.includes('Présentiel')) {
    return { tone: 'violet', icon: <GroupsRoundedIcon sx={{ fontSize: '0.95rem' }} /> };
  }
  if (val.includes('Mixte') || val.includes('virtuelle')) {
    return { tone: 'teal', icon: <LayersRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  return { tone: 'neutral', icon: <SchoolRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
};

const getFinancierStyle = (name = '') => {
  if (name.includes('DPC')) return { tone: 'blue' };
  if (name.includes('FIFPL')) return { tone: 'emerald' };
  if (name.includes('OPCO')) return { tone: 'violet' };
  if (name.includes('FIFPM')) return { tone: 'amber' };
  return { tone: 'neutral' };
};

// ── États du cycle de vie d'une formation (colonne « État ») ──
const ETATS = ['Active', 'Archivée', 'Brouillon'];
const DEFAULT_ETAT = 'Active';

const getEtatStyle = (val) => {
  if (val === 'Archivée') {
    return { tone: 'rose', icon: <ArchiveRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
  }
  if (val === 'Brouillon') {
    return { tone: 'amber', icon: <EditRoundedIcon sx={{ fontSize: '0.85rem' }} /> };
  }
  return { tone: 'emerald', icon: <CheckCircleRoundedIcon sx={{ fontSize: '0.9rem' }} /> };
};

/**
 * Taux de satisfaction d'une formation, sur 100.
 *
 * `satisfaction_pct` vient des questionnaires (même définition que le chiffre
 * publié sur le site vitrine) ; `global_average` est l'ancienne table
 * courses_satisfaction, conservée en repli car elle couvre des formations que
 * les questionnaires n'ont jamais évaluées. Renvoie 0 quand aucune des deux
 * n'est renseignée, ce que l'affichage traduit par « Pas d'évaluation ».
 */
const satisfactionPct = (item) => {
  const questionnaires = parseFloat(item.satisfaction_pct);
  if (Number.isFinite(questionnaires) && questionnaires > 0) return questionnaires;
  const legacy = parseFloat(item.global_average);
  return Number.isFinite(legacy) ? legacy : 0;
};

const getSatisfactionTier = (val) => {
  if (val >= 4.5) return { tone: 'emerald' };
  if (val >= 3.5) return { tone: 'blue' };
  if (val >= 2.5) return { tone: 'amber' };
  return { tone: 'rose' };
};

const Dash = () => <EmptyValue />;

const FormationResultTable = (props) => {
  const { formations, setFormations, currentPage, setCurrentPage, ...other } = props;
  const rows = [];
  const [currentIdFormation, setCurrentIdFormation] = useState(0);
  const { user } = useAuth();
  const { can } = usePermissions();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      {can('formations.export', user.id_service === 0) && <GridToolbarExport />}
    </GridToolbarContainer>
  );

  formations.filter((el) => el.status !== 'Supprimée').forEach((item) => {
    rows.push({
      id: item.id,
      name: item.name,
      image: item.image,
      format: item.format,
      duration: item.duration,
      actionType: item.action_type,
      professions: item.professions,
      programNumber: item.programNumberAll,
      financiers: item.financiers,
      // Satisfaction sur 5. Deux sources aux périmètres disjoints : le taux
      // calculé depuis les questionnaires (29 formations récentes) et l'ancienne
      // table courses_satisfaction (52 formations plus anciennes, jamais les
      // mêmes). On privilégie le taux questionnaires — c'est celui publié sur le
      // site vitrine — et on retombe sur l'ancienne valeur pour ne pas faire
      // disparaître les notes déjà affichées. Les deux sont sur 100.
      satisfaction: (Number(satisfactionPct(item)) / 20).toFixed(1),
      etat: item.etat || DEFAULT_ETAT,
    });
  });

  const handleEtatChange = async (id, etat) => {
    const previousEtat = formations.find((el) => el.id === id)?.etat;
    // Mise à jour optimiste : la cellule reflète immédiatement le choix.
    // Mise à jour fonctionnelle : `formations` est la liste filtrée, la remplacer
    // telle quelle ferait disparaître les formations masquées par les filtres.
    setFormations((prev) => prev.map((el) => (el.id === id ? { ...el, etat } : el)));
    try {
      await formationApi.editFormation('etat', etat, id, localStorage.getItem('accessToken'));
      toast.success(`État mis à jour : ${etat}`);
    } catch (err) {
      console.error(err);
      setFormations((prev) => prev.map((el) => (el.id === id ? { ...el, etat: previousEtat } : el)));
      toast.error('Il y a eu un souci lors de la mise à jour de l\'état !');
    }
  };

  const handleDelete = async (id) => {
    try {
      await formationApi.deleteFormation(id, localStorage.getItem('accessToken'));
      const tempFormations = [...formations];
      tempFormations[formations.map((el) => el.id).indexOf(id)].status = 'Supprimée';
      setFormations(tempFormations);
      toast.success('Formation supprimée !');
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error('Il y a eu un souci lors de la suppression !');
    }
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Formation',
      width: 380,
      renderCell: (cellValues) => {
        const name = cellValues.row.name || '';
        const prog = cellValues.row.programNumber;
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', py: 0.5, width: '100%' }}>
            <ListAvatar
              src={cellValues.row.image}
              name={name}
              size={46}
              fallback="FO"
            />
            <Box sx={{ ml: 1.75, minWidth: 0 }}>
              <Link
                component={RouterLink}
                to={`/dashboard/formations/${cellValues.row.id}`}
                sx={{
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '0.86rem',
                  color: 'text.primary',
                  lineHeight: 1.3,
                  transition: 'color 0.15s',
                  display: 'block',
                  '&:hover': { color: 'secondary.main' },
                }}
              >
                {name}
              </Link>
              {prog && prog !== 'N/A' ? (
                <Typography
                  sx={{
                    mt: 0.3,
                    fontSize: '0.68rem',
                    fontWeight: 600,
                    color: 'text.secondary',
                    fontFamily: '"JetBrains Mono", "Roboto Mono", monospace',
                    letterSpacing: '0.02em',
                  }}
                >
                  N° {prog}
                </Typography>
              ) : (
                <Typography sx={{ mt: 0.3, fontSize: '0.68rem', fontWeight: 600, color: 'text.disabled' }}>
                  Sans n° de programme
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'etat',
      headerName: 'État',
      width: 160,
      type: 'singleSelect',
      valueOptions: ETATS,
      renderCell: (cellValues) => {
        const val = cellValues.value || DEFAULT_ETAT;
        const s = getEtatStyle(val);
        const canEdit = can('formations.update', user.id_service === 0 || user.access_level === 0);
        return (
          <Select
            value={val}
            variant="standard"
            disableUnderline
            readOnly={!canEdit}
            onChange={(event) => handleEtatChange(cellValues.row.id, event.target.value)}
            renderValue={(v) => {
              const style = getEtatStyle(v);
              return <Pill icon={style.icon} label={v} tone={style.tone} />;
            }}
            MenuProps={{ PaperProps: { sx: { mt: 0.5 } } }}
            sx={{
              '& .MuiSelect-select': {
                p: 0,
                pr: canEdit ? '22px !important' : '0 !important',
                display: 'flex',
                alignItems: 'center',
                minHeight: 'auto !important',
                backgroundColor: 'transparent !important',
              },
              '& .MuiSelect-icon': {
                display: canEdit ? 'block' : 'none',
                right: 0,
                color: getTone(s.tone).color,
              },
              cursor: canEdit ? 'pointer' : 'default',
            }}
          >
            {ETATS.map((etat) => {
              const style = getEtatStyle(etat);
              return (
                <MenuItem key={etat} value={etat} sx={{ fontSize: '0.8rem', fontWeight: 600, gap: 1 }}>
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', color: getTone(style.tone).color }}>{style.icon}</Box>
                  {etat}
                </MenuItem>
              );
            })}
          </Select>
        );
      },
    },
    {
      field: 'format',
      headerName: 'Format',
      width: 150,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val) return <Dash />;
        const s = getFormatStyle(val);
        return <Pill icon={s.icon} label={val} tone={s.tone} />;
      },
    },
    {
      field: 'duration',
      headerName: 'Durée',
      width: 100,
      renderCell: (cellValues) => {
        if (!cellValues.value) return <Dash />;
        // Donnée factuelle : du texte suffit. Réserver les pastilles aux
        // valeurs qualitatives (état, format, profession, financeur).
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.6,
              color: 'text.secondary',
              fontSize: '0.8rem',
              fontWeight: 600,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            <AccessTimeRoundedIcon sx={{ fontSize: '0.95rem', opacity: 0.65 }} />
            {`${cellValues.value} h`}
          </Box>
        );
      },
    },
    {
      field: 'actionType',
      headerName: 'Action',
      width: 180,
      renderCell: (cellValues) => {
        if (!cellValues.value) return <Dash />;
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.7,
              minWidth: 0,
              color: 'text.secondary',
              fontSize: '0.8rem',
              fontWeight: 600,
            }}
          >
            <WorkOutlineRoundedIcon sx={{ fontSize: '0.95rem', opacity: 0.65, flexShrink: 0 }} />
            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {cellValues.value}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'professions',
      headerName: 'Professions',
      width: 250,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val || val === '—') return <Dash />;
        const list = val.split(',').map((p) => p.trim()).filter(Boolean);
        const visible = list.slice(0, 2);
        const rest = list.slice(2);
        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 0.5 }}>
            {visible.map((prof, idx) => (
              <Pill key={idx} label={prof} tone="teal" />
            ))}
            {rest.length > 0 && (
              <Tooltip title={rest.join(', ')} arrow>
                <Pill tone="teal" label={`+${rest.length}`} sx={{ cursor: 'default' }} />
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: 'financiers',
      headerName: 'Financeurs',
      width: 175,
      renderCell: (cellValues) => {
        const val = cellValues.value || '';
        if (!val) return <Dash />;
        const list = val.split(',').map((f) => f.trim()).filter(Boolean);
        // La ligne fait 74 px : au-delà de deux pastilles, le contenu
        // débordait et se retrouvait coupé. On plafonne comme la colonne
        // « Professions », le reste passe dans une info-bulle.
        const visible = list.slice(0, 2);
        const rest = list.slice(2);
        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 0.5 }}>
            {visible.map((fin, idx) => {
              const s = getFinancierStyle(fin);
              return (
                <Pill
                  key={idx}
                  icon={<PaymentsRoundedIcon sx={{ fontSize: '0.8rem' }} />}
                  label={fin}
                  tone={s.tone}
                />
              );
            })}
            {rest.length > 0 && (
              <Tooltip title={rest.join(', ')} arrow>
                <Pill tone="neutral" label={`+${rest.length}`} sx={{ cursor: 'default' }} />
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: 'satisfaction',
      headerName: 'Satisfaction',
      width: 150,
      renderCell: (cellValues) => {
        const val = Number(cellValues.value);
        if (Number.isNaN(val) || val <= 0) {
          return <EmptyValue>Pas d&apos;évaluation</EmptyValue>;
        }
        const tier = getTone(getSatisfactionTier(val).tone);
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              pl: 0.6,
              pr: 1.1,
              py: 0.45,
              borderRadius: '10px',
              backgroundColor: tier.bg,
              border: '1px solid',
              borderColor: tier.border,
            }}
          >
            <StarRoundedIcon sx={{ fontSize: '1.05rem', color: tier.color }} />
            <Typography sx={{ fontSize: '0.82rem', fontWeight: 800, color: tier.color, lineHeight: 1 }}>
              {val.toFixed(1)}
            </Typography>
            <Typography sx={{ fontSize: '0.68rem', fontWeight: 600, color: tier.color, opacity: 0.65, lineHeight: 1 }}>
              /5
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'actions',
      headerName: '',
      width: 64,
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => (
        <Tooltip title="Supprimer" arrow>
          <span>
            <IconButton
              onClick={() => { setCurrentIdFormation(cellValues.row.id); handleClickOpen(); }}
              disabled={!can('formations.delete', user.id_service === 0 || user.access_level === 0)}
              size="small"
              sx={{
                color: 'text.secondary',
                '&:hover': { backgroundColor: getTone('rose').bg, color: 'error.main' },
              }}
            >
              <DeleteOutlineIcon sx={{ fontSize: '1.2rem' }} />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <Card
      sx={{ overflow: 'hidden' }}
      {...other}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { p: 1 } }}
      >
        <DialogContent>
          <DialogContentText sx={{ fontWeight: 600, color: 'text.primary' }}>
            Souhaitez-vous vraiment supprimer cette formation ? Cette action est irréversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            color="error"
            onClick={() => handleDelete(currentIdFormation)}
          >
            Supprimer
          </Button>
          <Button
            onClick={handleClose}
            autoFocus
            color="secondary"
            variant="contained"
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>
      <DataGrid
        // Aucun style ici : couleurs, filets, typographie d'en-tête, survol
        // et pied de page viennent du thème (`MuiDataGrid`). Ne restent que
        // les règles de mise en page propres à cet écran.
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal !important',
            wordBreak: 'break-word !important',
            display: 'flex !important',
            alignItems: 'center !important',
          },
          '& .MuiDataGrid-cell[data-field="name"]': {
            lineHeight: '1.3 !important',
            py: '8px !important',
          },
        }}
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        initialState={{
          sorting: { sortModel: [{ field: 'name', sort: 'asc' }] },
        }}
        autoHeight
        rowHeight={74}
        rows={rows}
        columns={columns}
        page={currentPage}
        pageSize={20}
        rowsPerPageOptions={[30, 100]}
        disableSelectionOnClick
        components={{ Toolbar: CustomToolbar }}
        onPageChange={(newPage) => { setCurrentPage(newPage); }}
      />
    </Card>
  );
};

FormationResultTable.propTypes = {
  formations: PropTypes.array,
  setFormations: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

export default FormationResultTable;
